import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontSize: "48px",
  lineHeight: 1.17
}));

export const TopIndentBox = styled(Box)(({ theme }) => ({
  marginTop: "40px"
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginLeft: "20px",
  fontSize: "20px",
  fontWeight: 600,
  color: theme.palette.text.color
}));

export const Username = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  lineHeight: "1.3",
  margin: "0",
  color: theme.palette.text.color
}));

export const SectionText = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  lineHeight: "1.3",
  margin: "0",
  color: theme.palette.text.color,
  marginBottom: "60px"
}));

export const SectionTitle = styled(Box)(({ theme }) => ({
  marginBottom: "60px"
}));

export const ContinueButtonWrapper = styled(Box)(({ theme }) => ({
  margin: "20px 0 40px 0"
}));

export const DetailsContinueButton = styled(Box)(({ theme }) => ({
  marginTop: 5
}));

export const ContinueButtonGrid = styled(Box)(({ theme }) => ({
  padding: 20
}));

export const DeleteButton = styled("div")(({ theme }) => ({
  height: "100%",
  outline: "none"
}));

export const ContinueButtonContainer = styled(Box)(({ theme }) => ({
  flexWrap: "nowrap",
  [theme.breakpoints.only("xs")]: {
    flexDirection: "column"
  }
}));

export const ContinueBtn = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    alignSelf: "flex-end",
    marginTop: "10px"
  }
}));

export const RadioButtonRoot = styled(Box)(({ theme }) => ({
  width: "calc(33.33% - 20px)",
  padding: 5
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  background: "none",
  border: "1px solid #000000",
  padding: "5px 32px",
  minHeight: 30,
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.1)"
  }
}));

export const Label = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main
}));

export const MapPreviewContainer = styled(Box)(({ theme }) => ({
  height: 250,
  borderRadius: 10,
  margin: 10,
  width: "100%",
  marginBottom: 20
}));

export const PreviewContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    position: "absolute",
    right: 5,
    width: "calc(50% - 10px)"
  }
}));
